export default {
  methods: {
    systemErrorNotification (
      title = 'SYSTEM ERROR!',
      message = 'Something went wrong, please try again!',
    ) {
      (this as any).$notify({
        title: title,
        verticalAlign: 'bottom',
        horizontalAlign: 'left',
        message: message,
        type: 'danger',
        icon: 'fas fa-bomb',
      });
    },
    successNotification (
      title = 'RECORDS SAVED!',
      message = 'Record have been saved successfully',
    ) {
      (this as any).$notify({
        title: title,
        verticalAlign: 'bottom',
        horizontalAlign: 'left',
        message: message,
        type: 'success',
        icon: 'fas fa-check',
      });
    },
  },
};
